export default __webpack_public_path__ + "static/media/rake_shovel.54cc4b33.png";